import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getExampleConceptExplore = (page, rowsPerPage, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/explore_concepts?page=${page}&rowsPerPage=${rowsPerPage}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getConceptByKeyword = (
  granularityLevel,
  rootConcept,
  callback
) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/explore?granularityLevel=${granularityLevel}&${rootConcept}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getConceptDetailSummaryById = async (id) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/summary?conceptId=${id}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getConceptRelatedKeywordCloudById = async ({
  id,
  keywords,
  top_k,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/concept/related_keyword_cloud?conceptId=${id}`;
  if (keywords?.length > 0) {
    let params = new URLSearchParams();
    keywords.forEach((keyword) => {
      if (keyword) {
        params.append("rootConcept", keyword.value);
      }
    });
    url += `&${params.toString()}`;
  }

  if (!!top_k) {
    url += `&top_k=${top_k}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getConceptNotablePapersById = async ({
  id,
  titleQuery,
  keyword,
  page,
  rowsPerPage,
  numPages,
  orderBy,
  order,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/concept/notable_papers?conceptId=${id}`;
  if (titleQuery) {
    url += `&titleQuery=${titleQuery}`;
  }
  if (keyword) {
    url += `&keyword=${keyword}`;
  }
  if (page) {
    url += `&page=${page}`;
  }
  if (rowsPerPage) {
    url += `&rowsPerPage=${rowsPerPage}`;
  }
  if (numPages) {
    url += `&numPages=${numPages}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (order) {
    url += `&order=${order}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getConceptSurveyPapersById = async ({
  id,
  page,
  rowsPerPage,
  orderBy,
  order,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/concept/survey_papers?conceptId=${id}`;
  if (page) {
    url += `&page=${page}`;
  }
  if (rowsPerPage) {
    url += `&rowsPerPage=${rowsPerPage}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (order) {
    url += `&order=${order}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getRelatedConceptByID = (
  id,
  granularityLevel,
  params,
  callback
) => {
  const axios = AxiosConfigExplore();
  let url;
  if (params) {
    url = `/concept/related_concepts?conceptId=${id}&granularityLevel=${granularityLevel}&${params}`;
  } else {
    url = `/concept/related_concepts?conceptId=${id}&granularityLevel=${granularityLevel}`;
  }
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getConceptTopPapersByID = (
  id,
  page,
  rowsPerPage,
  orderBy,
  callback
) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/top_papers?conceptId=${id}&page=${
    page - 1
  }&rowsPerPage=${rowsPerPage}&orderBy=${orderBy}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getConceptTopSurveyPapersByID = (
  id,
  page,
  rowsPerPage,
  orderBy,
  callback
) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/survey_papers?conceptId=${id}&page=${
    page - 1
  }&rowsPerPage=${rowsPerPage}&orderBy=${orderBy}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getConceptTopScholarsByID = async ({
  id,
  page,
  rowsPerPage,
  keyword,
}) => {
  const axios = AxiosConfigExplore();
  let url = `/concept/top_authors?conceptId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;

  if (keyword) {
    url += `&keyword=${keyword}`;
  }

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getConceptTopUnitsByID = async ({ id, page, rowsPerPage }) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/top_units?conceptId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getConceptTopInstitutionsByID = async ({
  id,
  page,
  rowsPerPage,
}) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/top_institutions?conceptId=${id}&page=${page}&rowsPerPage=${rowsPerPage}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};

export const getSearchConcepts = (filters, callback) => {
  // const axios = AxiosConfigExplore();
  // const url = `/concept/${params}`;
  // axios
  //   .get(url)
  //   .then((res) => {
  //     var data_copy = Object.assign(res.data);

  //     if (data_copy.length > 0 && data_copy[0].name && !data_copy[0].value) {
  //       for(let i = 0; i < data_copy.length; i ++ ) {
  //         data_copy[i].value = data_copy[i].name;
  //       }
  //     }
  //     callback(data_copy);
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   });
  const axios = AxiosConfigExplore();
  let url = `/concept/search`;

  axios
    .post(url, filters)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSearchConceptsNew = (filters, callback) => {
  const axios = AxiosConfigExplore();
  let url = `/concept/semantic_search/`;

  axios
    .post(url, filters)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getSuggestSearchConcepts = (params, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/suggest/${params}`;
  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getLearningMaterialById = (id, page, rowsPerPage, callback) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/learning_materials?conceptId=${id}&page=${
    page - 1
  }&rowsPerPage=${rowsPerPage}`;

  axios
    .get(url)
    .then((res) => {
      callback(res.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getConceptStatisticsById = async (id) => {
  const axios = AxiosConfigExplore();
  const url = `/concept/stats?conceptId=${id}`;

  try {
    const res = await axios.get(url);
    return res.data;
  } catch (err) {
    console.log(err);
  }
};
